import { createReducer } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';

import appointmentActions from './appointmentActions';
const searchParams = new URL(document.location)?.searchParams;
const fetchClientsList = (state, action) => {
  return action.payload.sort(function (a, b) {
    if (a?.name?.toLowerCase() < b?.name?.toLowerCase()) {
      return -1;
    }
    if (a?.name?.toLowerCase() > b?.name?.toLowerCase()) {
      return 1;
    }
    return 0;
  });
};

const addNewClient = (state, action) => {
  return [...state, action.payload].sort(function (a, b) {
    if (a?.name?.toLowerCase() < b?.name?.toLowerCase()) {
      return -1;
    }
    if (a?.name?.toLowerCase() > b?.name?.toLowerCase()) {
      return 1;
    }
    return 0;
  });
};
const fetchServicesList = (state, action) => action.payload;
const selectClient = (state, action) => [...state, action.payload];
const unselectClient = (state, action) => state.filter(item => item != action.payload);
const updatedOffTimeQueue = (state, action) => {
  // console.log(action.payload);
  return { ...state, ...action.payload };
};
const updatedAppointment = (state, action) => {
  return { ...state, ...action.payload };
};
const clearOffTimeQueue = (state, action) => {
  return {
    ...state,
    ...{ date: '', time: '', duration: config.defaultOffTimeDuration, note: '', address: '', appointment_id: '' },
  };
};
const clearAppointment = (state, action) => {
  return {
    ...state,
    ...{
      isNew: true,
      date: '',
      time: '',
      price: 0,
      discount: 0,
      prepayment: 0,
      price_before_discount: 0,
      duration: config.defaultAppointmentDuration,
      note: '',
      info_for_client: '',
      zoom_link: '',
      address: '',
      appointment_id: '',
    },
  };
};
const selectService = (state, action) => action.payload;
const fetchAvailableSlots = (state, action) => action.payload.workers;
const setPaymentRequiredData = (state, action) => action.payload;

const handleSetPopupData = (state, action) => {
  return { ...state, ...action.payload };
};

const handleHidePopup = () => {
  return { points: 0, showPopup: false, order: null, total_count: 0 };
};

const handleShowPopup = state => {
  return { ...state, showPopup: true };
};

const offTimeQueue = createReducer(
  {
    worker_id: Number(searchParams?.get('worker_id')) || config.activeWorkerId,
    appointment_id: searchParams?.get('appointment_id'),
    calendar_view_type: searchParams?.get('calendar_view_type') || config.calendar.initialView,
    date: searchParams?.get('off_time') && searchParams?.get('start') ? searchParams?.get('start').split('T')[0] : '',
    time:
      searchParams?.get('off_time') && searchParams?.get('start')
        ? searchParams?.get('start').split('T')[1]?.slice(0, 5)
        : '',
    duration:
      (searchParams?.get('off_time') && searchParams?.get('duration') >= config?.minOffTimeDuration
        ? searchParams?.get('duration')
        : config.defaultOffTimeDuration) || config.defaultOffTimeDuration,
    note: (searchParams?.get('off_time') && searchParams?.get('note')) || '',
    address: (searchParams?.get('off_time') && searchParams?.get('address')) || '',
    off_time: searchParams?.get('off_time') || '',
  },
  {
    [appointmentActions.updatedOffTime]: updatedOffTimeQueue,
    [appointmentActions.clearOffTimeData]: clearOffTimeQueue,
  },
);
const appointment = createReducer(
  {
    isNew: !searchParams?.get('appointment_id'),
    prepayment: Number(searchParams?.get('prepayment')) || 0,
    worker_id: Number(searchParams?.get('worker_id')) || config.activeWorkerId,
    appointment_id: searchParams?.get('appointment_id'),
    calendar_view_type: searchParams?.get('calendar_view_type') || config.calendar.initialView,
    date: searchParams?.get('start') ? searchParams?.get('start').split('T')[0] : '',
    time:
      searchParams?.get('start')
        ? searchParams?.get('start').split('T')[1]?.slice(0, 5)
        : '',
    price: Number(searchParams?.get('price')) || 0,
    discount: 0,
    price_before_discount: Number(searchParams?.get('price_before_discount')) || 0,
    duration:
      searchParams?.get('duration') >= config?.minAppointmentDuration
        ? searchParams?.get('duration') || config.defaultAppointmentDuration
        : config.defaultAppointmentDuration,
    note: searchParams?.get('note') || '',
    is_online_booking:
      (searchParams.get('is_online_booking') && searchParams.get('is_online_booking') === 'true') || false,
    info_for_client: searchParams?.get('info_for_client') || '',
    zoom_link: searchParams?.get('zoom_link') || '',
    address: searchParams?.get('address') || '',
  },
  {
    [appointmentActions.updatedAppointment]: updatedAppointment,
    [appointmentActions.clearAppointmentData]: clearAppointment,
  },
);
const availableSlots = createReducer(
  {},
  {
    [appointmentActions.fetchSlotsSuccess]: fetchAvailableSlots,
    [appointmentActions.clearSlots]: () => ({}),
  },
);
const paymentRequiredData = createReducer(null, {
  [appointmentActions.setPaymentRequiredData]: setPaymentRequiredData,
  [appointmentActions.clearPaymentRequiredData]: () => null,
  [appointmentActions.createAppointmentSuccess]: () => null,
});
const slotsLoader = createReducer(false, {
  [appointmentActions.fetchSlotsRequest]: () => true,
  [appointmentActions.fetchSlotsSuccess]: () => false,
});
const clientsList = createReducer([], {
  [appointmentActions.fetchClientsListSuccess]: fetchClientsList,
  [appointmentActions.addClientSuccess]: addNewClient,
});
const servicesList = createReducer([], {
  [appointmentActions.fetchServicesListSuccess]: fetchServicesList,
});
const clientsLimitValueFromServices = createReducer(1, {
  [appointmentActions.setClientsLimit]: (state, { payload }) => payload,
});
const selectedClients = createReducer(searchParams?.get('clients') ? JSON.parse(searchParams?.get('clients')) : [], {
  [appointmentActions.selectClient]: selectClient,
  [appointmentActions.unselectClient]: unselectClient,
  [appointmentActions.setSelectedClients]: (state, { payload }) => payload,
  [appointmentActions.createAppointmentSuccess]: () => [],
  [appointmentActions.updateAppointmentSuccess]: () => [],
});
const selectedServices = createReducer(searchParams?.get('services') ? JSON.parse(searchParams?.get('services')) : [], {
  [appointmentActions.selectService]: selectService,
  [appointmentActions.createAppointmentSuccess]: () => [],
  [appointmentActions.updateAppointmentSuccess]: () => [],
});

const clientsLoader = createReducer(false, {
  [appointmentActions.fetchClientsListRequest]: () => true,
  [appointmentActions.fetchClientsListSuccess]: () => false,
  [appointmentActions.addClientRequest]: () => true,
  [appointmentActions.addClientSuccess]: () => false,
  [appointmentActions.clearPaymentRequiredData]: () => false,
});

const servicesLoader = createReducer(true, {
  [appointmentActions.fetchServicesListRequest]: () => true,
  [appointmentActions.fetchServicesListSuccess]: () => false,
  [appointmentActions.servicesStopLoader]: () => false,
});

const loader = createReducer(false, {
  [appointmentActions.createOffTimeRequest]: () => true,
  [appointmentActions.createOffTimeSuccess]: () => false,
  [appointmentActions.updateOffTimeRequest]: () => true,
  [appointmentActions.updateOffTimeSuccess]: () => false,
  [appointmentActions.createAppointmentRequest]: () => true,
  [appointmentActions.createAppointmentSuccess]: () => false,
  [appointmentActions.bookingAppointmentRequest]: () => true,
  [appointmentActions.bookingAppointmentSuccess]: () => false,
  [appointmentActions.editBookedAppointmentRequest]: () => true,
  [appointmentActions.editBookedAppointmentSuccess]: () => false,
  [appointmentActions.updateAppointmentRequest]: () => true,
  [appointmentActions.updateAppointmentSuccess]: () => false,
  [appointmentActions.clearPaymentRequiredData]: () => false,
});

const addQueue = createReducer(false, {
  [appointmentActions.showAddAppointmentToast]: () => true,
  [appointmentActions.hideAddAppointmentToast]: () => false,
});

const chosenQueueStartTime = createReducer(
  {},
  {
    [appointmentActions.scrollToAppointment]: (state, action) => action.payload,
    [appointmentActions.clearScrollAppointment]: () => ({}),
  },
);

const editQueue = createReducer(false, {
  [appointmentActions.showEditAppointmentToast]: () => true,
  [appointmentActions.hideEditAppointmentToast]: () => false,
});

const earnRegularPopup = createReducer(
  {
    points: 0,
    showPopup: false,
    order: null,
    total_count: 0,
  },
  {
    [appointmentActions.setEarnRegularPopupData]: handleSetPopupData,
    [appointmentActions.showEarnRegularPopup]: handleShowPopup,
    [appointmentActions.hideEarnRegularPopup]: handleHidePopup,
  },
);

const trophyPopup = createReducer(
  {
    points: 0,
    showPopup: false,
    order: null,
    total_count: 0,
  },
  {
    [appointmentActions.setTrophyPopupData]: handleSetPopupData,
    [appointmentActions.showTrophyPopup]: handleShowPopup,
    [appointmentActions.hideTrophyPopup]: handleHidePopup,
  },
);

export default combineReducers({
  earnRegularPopup,
  trophyPopup,
  appointment,
  servicesList,
  servicesLoader,
  chosenQueueStartTime,
  selectedServices,
  availableSlots,
  slotsLoader,
  clientsList,
  addQueue,
  editQueue,
  loader,
  offTimeQueue,
  selectedClients,
  clientsLoader,
  paymentRequiredData,
  clientsLimitValueFromServices,
});
